module.exports = __webpack_public_path__ + "img/group-initial-screen.2cc2b079.svg";